<template>
    <div class="row m-0 p-5 d-flex">
        <div class="col-12 flex-shrink-0 text-center text-sm-start">
            <router-link :to="{name: 'index'}" class="btn btn-dark bg-site me-2"><i class="fas fa-home me-2"></i>{{ TR.home }}</router-link>
            <a @click="$router.go(-1)" class="btn btn-dark bg-site"><i class="fas fa-arrow-left me-2"></i>{{ TR.back }}</a>
        </div>
    </div>
    <div class="main404 row m-0 p-5 d-flex">
        <div class="col-12 flex-grow-1 text-center">
            <SVGLogo fill="brown" textFill="white" />
            <div class="msg_text mt-4">{{ TR.page_not_found }}</div>
        </div>
    </div>
    <!-- <div class="main">
        <SVGLogo fill="brown" textFill="white" />
        <div class="msg_text">{{ TR.page_not_found }}</div>
    </div> -->
</template>

<script>
import { ref, watchEffect } from "vue";

import { useStore } from '@/system_modules/store';
import { useRoute } from "vue-router";

import SVGLogo from '@/components/SVGLogo';

export default {
    name: "NotFoundP",
    title: "page_not_found",
    components: {
        SVGLogo,
    },
    setup(){
        const store = useStore();
        const route = useRoute();

        const TR = ref([]);

        const def_lang = route.params && route.params.lang !== undefined ? route.params.lang : "az";
        store.setLang(def_lang);

        watchEffect(() => {
            TR.value = store.getTranslation();
        });

        return { TR };
    }
};
</script>

<style lang="scss" scoped>
@media(min-width: 576px) {
    .main {
        padding-top: 15vh;
        text-align: center;
        font-size: 36pt;
    }
    .main img {
        width: 20%;
        margin-bottom: 30px;
    }
    .msg_text {
        font-size: 30pt;
        font-weight: bold;
        color: #ff0000;
    }
}
@media(max-width: 576px) {
    .main {
        padding-top: 15vh;
        text-align: center;
    }
    .main404 img {
        width: 100%;
        margin-bottom: 30px;
    }
    .msg_text {
        font-size: 20pt;
        font-weight: bold;
        color: #ff0000;
    }
}
</style>
